import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import type { MutationKey, QueryKey } from "@tanstack/react-query";

import { captureError } from "./telemetry";

// Only the leading segment of a key is reported. Query keys in this app routinely carry patient
// ids, search terms and date ranges after the resource name, so serializing the whole key would
// ship PHI to telemetry — the resource name alone is enough to tell which query broke.
function resourceOf(key: QueryKey | MutationKey | undefined): string | null {
  const first = Array.isArray(key) ? key[0] : key;
  return typeof first === "string" ? first : null;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        captureError(error, {
          source: "react-query",
          type: "query",
          resource: resourceOf(query.queryKey),
        });
      },
    }),
    mutationCache: new MutationCache({
      onError: (error, _variables, _context, mutation) => {
        captureError(error, {
          source: "react-query",
          type: "mutation",
          resource: resourceOf(mutation.options.mutationKey),
        });
      },
    }),
  });
}
